module.exports = "/_next/static/images/Hero@2x-4b73ddf7eff4a6b896249b5c640020cd.webp";